import React from "react";
import { FormattedMessage } from "react-intl";
import { IconWrapper } from "../../components/utils/IconWrapper";
import { SketchPicker } from "react-color";
import { IoIosHelpCircleOutline } from "react-icons/io";

interface FormProps {
  id: string;
  placeholder?: string;
  value?: string | number;
  question?: string;
  containerStyle?: string;
  divider?: string;
  repeatable?: boolean;
  inputStyle?: string;
  divStyle?: string;
  labelStyle?: string;
  dividerHeaderStyle?: string;
  register?: any;
  errors?: Record<string, Object>;
  link?: string | boolean;
  cursiveLabel?: string;
  repeatableHeader?: string | boolean;
  repeatableKey?: { key: string; last: boolean; amount: number };
  required?: boolean;
  overlayId?: string;
  changeAmount?: (key: string, direction: number) => void;
  onBlur?: (event: any) => void;
  handleInputChange: (color: string, id: string, type?: string) => void;
  overlayToggle?: (id: string) => void;
}

export const FormColor: React.FC<FormProps> = ({
  id,
  placeholder,
  handleInputChange,
  question,
  value,
  containerStyle,
  errors,
  link,
  onBlur,
  repeatableKey,
  changeAmount,
  overlayId,
  divider,
  repeatable,
  inputStyle,
  labelStyle,
  divStyle,
  dividerHeaderStyle,
  register,
  cursiveLabel,
  repeatableHeader,
  required,
  overlayToggle,
}) => {
  //TODO: Tänne pitää luoda sisäinen tila komponentille, jolla tiedetään milloin näytetään pickeriä
  // Aluksi näytetään vain väriä, ja kun sitä klikataan, avajutuu pikkeri.

  const styles = inputStyle ? inputStyle : "self-center";

  const textValueStyle = "self-center text-lg";

  const divStyles = divStyle ? divStyle : "flex flex-col mb-4 ";

  const labelStyles = labelStyle
    ? labelStyle
    : "m-2 uppercase font-bold text-lg text-brand-dark_blue";

  const linkStyles =
    "hover:text-brand-dark_blue text-brand-blue mb-2 uppercase font-bold text-lg";

  const buttonStyle =
    "bg-blue-400 hover:bg-brand-blue text-brand-white py-2 px-4 rounded m-5 w-auto";

  const participantId = repeatable ? id.split("_")[1] : ""; //expected id is 'BLABLABLA_2' => 2

  const dividerHeaderStyles = dividerHeaderStyle
    ? dividerHeaderStyle
    : "m-2 uppercase font-bold text-lg text-brand-blue";

  const dividerStyles = divider ? divider : "";
  const containerStyles = containerStyle ? containerStyle : "";

  const errorDiv = errors ? (
    errors[id] ? (
      <p className='text-red-400 ml-4'>
        {" "}
        <FormattedMessage id={errors[id]["message"]} />
      </p>
    ) : null
  ) : null;

  const requiredAsterisk = required ? (
    <span className='font-normal text-red-500'>*</span>
  ) : null;

  const mouseHoverTrigger = (e: any) => {
    overlayToggle(overlayId);
  };

  const helpIcon = overlayId ? (
    <IconWrapper styles={"self-center"}>
      <IoIosHelpCircleOutline
        onMouseEnter={(e) => mouseHoverTrigger(e)}
        onMouseLeave={(e) => mouseHoverTrigger(e)}
        size={30}
      ></IoIosHelpCircleOutline>
    </IconWrapper>
  ) : null;

  const labelTag =
    typeof link === "string" ? (
      <span className={`${linkStyles}`}>
        <a href={link} target='_blank' rel='noreferrer'>
          {question}
          {requiredAsterisk}
        </a>
      </span>
    ) : question && overlayId ? (
      <div className='flex relative'>
        <span className={`${labelStyles}`}>
          {question}
          {requiredAsterisk}
        </span>
        {helpIcon}
      </div>
    ) : question ? (
      <span className={`${labelStyles}`}>
        {question}
        {requiredAsterisk}
      </span>
    ) : null;

  const additionalLabel = cursiveLabel ? (
    <p className='text-brand-dark_blue italic ml-4'>{cursiveLabel}</p>
  ) : null;

  const hideDecreaseRepeatableStyle = repeatableKey
    ? Number(repeatableKey.amount) === 1
      ? "invisible focus:outline-none outline-none"
      : "visible"
    : null;

  const lastOfRepeatGroup = repeatableKey
    ? repeatableKey.last
      ? true
      : false
    : false;
  const repeatableButtons = lastOfRepeatGroup ? (
    <div className='flex flex-row justify-between'>
      <button
        onClick={() => changeAmount(repeatableKey.key, 1)}
        type='button'
        className={`${buttonStyle}`}
      >
        <FormattedMessage id='Form.Repeat_add' />
      </button>
      <button
        onClick={() => changeAmount(repeatableKey.key, -1)}
        type='button'
        className={`${buttonStyle} ${hideDecreaseRepeatableStyle}`}
      >
        <FormattedMessage id='Form.Repeat_remove' />
      </button>
    </div>
  ) : null;

  return (
    <div className={`${divStyles} ${containerStyles} ${dividerStyles}`}>
      {divider && repeatable ? (
        <span className={`${dividerHeaderStyles}`}>
          {repeatableHeader} {participantId}
        </span>
      ) : null}
      {labelTag}
      {additionalLabel}
      <SketchPicker
        className={styles}
        id={id}
        name={id}
        ref={register}
        onChangeComplete={(c) =>
          handleInputChange(
            `rgba(${c.rgb.r}, ${c.rgb.g}, ${c.rgb.b}, ${c.rgb.a})`,
            id
          )
        }
        onBlur={onBlur ? (e) => onBlur(e) : null}
        color={value}
      />
      <span className={textValueStyle}>{value}</span>
      {errorDiv}
      {repeatableButtons}
    </div>
  );
};

export default FormColor;
